import type { CampaignPurpose } from '@workspace/types';
import { Label } from '@/components/ui/label';
import { noticeVariableOptions } from '../api/noticeTemplateVariables';

type Props = {
  slots: number;
  purpose: CampaignPurpose;
  value: string[];
  onChange: (next: string[]) => void;
};

/** Que dato va en cada variable de una plantilla de WhatsApp traida desde Meta. */
export function NoticeTemplateVariableFields({ slots, purpose, value, onChange }: Props) {
  if (slots === 0) {
    return null;
  }
  const options = noticeVariableOptions(purpose);
  const setSlot = (index: number, key: string) => {
    const next = Array.from({ length: slots }, (_, position) => value[position] ?? '');
    next[index] = key;
    onChange(next);
  };
  return (
    <fieldset className='space-y-3 md:col-span-2'>
      <legend className='text-sm font-medium'>Qué dato va en cada variable</legend>
      <div className='grid gap-3 md:grid-cols-2'>
        {Array.from({ length: slots }, (_, index) => (
          <div key={index} className='space-y-1'>
            <Label htmlFor={`notice-wa-var-${index + 1}`}>{`Variable {{${index + 1}}}`}</Label>
            <select
              id={`notice-wa-var-${index + 1}`}
              className='flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm'
              value={value[index] ?? ''}
              onChange={event => setSlot(index, event.target.value)}
            >
              <option value=''>Elegí un dato</option>
              {options.map(option => (
                <option key={option.key} value={option.key}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </fieldset>
  );
}
